export const PEOPLE_PAGES_FEATURE = 'people_pages'
export const PEOPLE_PAGES_PERMISSION = 'people-ui-pages'

export const isPeoplePagesQueryEnabled = (canViewPeoplePages: boolean): boolean => canViewPeoplePages

export const isPeopleIntegrationQueryEnabled = (
  canViewPeoplePages: boolean,
  isIdentifiedVisitor: boolean,
  hasIntegratedPartner: boolean
): boolean => canViewPeoplePages && isIdentifiedVisitor && hasIntegratedPartner
